/**
 * Atelier Diamante — Card video hover previews
 * Plays a product's muted MP4 (.ad-card__preview) on hover, one card at a time.
 * Desktop-only: gated on (hover: hover) and (pointer: fine), so touch devices
 * keep the static image and download zero video bytes (preload="none").
 * Shared by ad-engagement-rings and ad-featured-rings; guarded against double-init.
 */
(function () {
  'use strict';
  if (window.__adCardVideoInit) return;
  window.__adCardVideoInit = true;

  function init() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var current = null;

    function stop(card) {
      if (!card) return;
      card.classList.remove('is-previewing');
      var v = card.querySelector('.ad-card__preview');
      if (v) {
        v.pause();
        v.currentTime = 0;
      }
    }

    var videos = document.querySelectorAll('.ad-card__preview');
    Array.prototype.forEach.call(videos, function (video) {
      var card = video.closest('.ad-er-card, .ad-ring-card, .adcc-card');
      if (!card) return;

      card.addEventListener('mouseenter', function () {
        if (current && current !== card) stop(current);
        current = card;
        card.classList.add('is-previewing');
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      });

      card.addEventListener('mouseleave', function () {
        stop(card);
        if (current === card) current = null;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
